export default class BgMovie {
    constructor() {
        this.init();
    }

    init() {
        this.playMov();
    }

    //低電力モード対策：低電力モードの時は背景画像が見えるように
    playMov() {
        const bgVideo = document.getElementById('bgvideo');

        window.addEventListener('load', () => {
            bgVideo.play();
        });
    }
}
